import { getContext } from 'svelte';
import { NAV_BAR_CONTEXT } from '../../constants/nav-bar-context';
import type { NavPopover } from '../createNavPopover';

export interface NavBarContext {
	popover?: NavPopover;
}

export const getNavBarContext = () => {
	return getContext<NavBarContext>(NAV_BAR_CONTEXT);
};
